import React, { PropsWithChildren } from "react";
import { useModal } from "@blacknut/react-sdk";
import { Routes, useLocation, useMatch } from "react-router-dom-v5-compat";

export const ModalRoutes = ({ children }: PropsWithChildren<unknown>) => {
  const location = useLocation();
  const background = location.state && location.state.background;
  const { Modal } = useModal();
  const match = useMatch("/modal");

  return (
    <>
      <Routes location={background || location}>{children}</Routes>

      {/* Show the modal when a background page is set */}
      {match && Modal && <Modal isOpen={true} />}
    </>
  );
};
